<template>
  <div class="translations-provider">
    <slot />
  </div>
</template>

<script setup>
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  provide,
  reactive,
} from "vue";

// Translations props is
// {
//   "homepage.title": "Welcome to Our Site",
//   "homepage.subtitle": "Your gateway to amazing content",
// }
const { translations, aft = false } = defineProps({
  translations: Object,
  aft: Boolean,
});

// Get any parent translations. Remember the providers can be nested
const parentTranslations = inject("translations", {});
const localOverrides = reactive({});

const allTranslations = computed(() => ({
  ...parentTranslations,
  ...translations,
  ...localOverrides,
}));

// Provide merged translations to children
provide("translations", allTranslations);

const listenForUpdates = (event) => {
  const { key, value } = event.detail;

  console.log("Received translation update:", key, value);
  if (translations[key]) {
    console.log("Updating local override for key:", key);
    localOverrides[key] = value;
  }
};

onMounted(() => {
  window.addEventListener("aft:translations-updated:vue", listenForUpdates);
});

onUnmounted(() => {
  window.removeEventListener("aft:translations-updated:vue", listenForUpdates);
});
</script>
